<template>
  <div class="maincontainer">
    <lrBox @close="handleCloseLrBox" v-show="lrBoxVisible" ref="lrBoxDom" />
    <joymew-header @openLogin="handleOpenLogin" @openRegister="handleOpenRegister"></joymew-header>
    <banner></banner>
    <div class="newhome-go-list">
      <div class="ngl-top">
        <img
          @click="to('/app/')"
          src="@/assets/2025home/app-go.png"
          alt="嗨喵悦动,嗨喵互动,嗨喵App"
        />
        <img
          @click="to('https://www.hudongmiao.com/course/tc0tc2.html')"
          src="@/assets/2025home/line-go.png"
          alt="嗨喵悦动,嗨喵互动,嗨喵台词"
        />
        <img
          @click="to('/setmeal/')"
          src="@/assets/2025home/meal-go.png"
          alt="嗨喵悦动,嗨喵互动,嗨喵套餐"
        />
        <img
          @click="
            to(
              'https://screen.hudongmiao.com/#/?liveId=7b249edb6f5b420c82b31f485080b1a7&screenType=wedding'
            )
          "
          src="@/assets/2025home/function-go.png"
          alt="嗨喵悦动,嗨喵互动,嗨喵功能"
        />
      </div>
      <div class="ngl-bottom">
        <div class="ngl-bottom-item">
          <img
            class="ngl-bottom-img"
            src="@/assets/2025home/hdzbf.png"
            alt="嗨喵悦动,嗨喵互动,活动主办方"
          />
          <div class="ngl-bottom-info">
            <div class="count-num">
              <span id="hdzbf">15468</span>
              <span>+</span>
            </div>
            <span class="label">活动主办方</span>
          </div>
        </div>
        <div class="ngl-bottom-item">
          <img
            class="ngl-bottom-img"
            src="@/assets/2025home/zcls.png"
            alt="嗨喵悦动,嗨喵互动,主持老师"
          />
          <div class="ngl-bottom-info">
            <div class="count-num">
              <span id="zcls">52896</span>
              <span>+</span>
            </div>
            <span class="label">主持老师</span>
          </div>
        </div>
        <div class="ngl-bottom-item">
          <img
            class="ngl-bottom-img"
            src="@/assets/2025home/hdcc.png"
            alt="嗨喵悦动,嗨喵互动,活动场次"
          />
          <div class="ngl-bottom-info">
            <div class="count-num">
              <span id="hdcc">865679</span>
              <span>+</span>
            </div>
            <span class="label">活动场次</span>
          </div>
        </div>
        <div class="ngl-bottom-item">
          <img
            class="ngl-bottom-img"
            src="@/assets/2025home/xccyrc.png"
            alt="嗨喵悦动,嗨喵互动,现场参与人次"
          />
          <div class="ngl-bottom-info">
            <div class="count-num">
              <span id="xccyrc">103675984</span>
              <span>+</span>
            </div>
            <span class="label">现场参与人次</span>
          </div>
        </div>
      </div>
    </div>
    <div class="adaptivePlace">
      <label-202510 :font-size="30" :text-width="140">适用场景</label-202510>
      <div class="adativeItems">
        <div class="adativeItem">
          <div :class="[place2 == true ? 'subtitle1' : 'subtitle']">
            <img
              v-if="place2 == true"
              src="@/assets/2025home/hqxq-active.png"
              alt="婚庆相亲"
              class="item-icon"
            />
            <img v-else src="@/assets/2025home/hqxq.png" alt="婚庆相亲" class="item-icon" />
            婚庆相亲
          </div>
        </div>
        <div class="adativeItem">
          <div :class="[place1 == true ? 'subtitle1' : 'subtitle']">
            <img
              v-if="place1 == true"
              src="@/assets/2025home/qynh-active.png"
              alt="企业年会"
              class="item-icon"
            />
            <img v-else src="@/assets/2025home/qynh.png" alt="企业年会" class="item-icon" />
            企业年会
          </div>
        </div>

        <div class="adativeItem">
          <div :class="[place3 == true ? 'subtitle1' : 'subtitle']">
            <img
              v-if="place3 == true"
              src="@/assets/2025home/jbhy-active.png"
              alt="酒吧户外"
              class="item-icon"
            />
            <img v-else src="@/assets/2025home/jbhy.png" alt="酒吧户外" class="item-icon" />
            酒吧户外
          </div>
        </div>
        <div class="adativeItem">
          <div :class="[place4 == true ? 'subtitle1' : 'subtitle']">
            <img
              v-if="place4 == true"
              src="@/assets/2025home/qyyx-active.png"
              alt="企业营销"
              class="item-icon"
            />
            <img v-else src="@/assets/2025home/qyyx.png" alt="企业营销" class="item-icon" />
            企业营销
          </div>
        </div>
      </div>
    </div>
    <div class="adativeItemscontainer">
      <!-- 企业年会 -->
      <div class="items" v-if="place1">
        <div class="item">
          <img
            v-lazy="require('../assets/partyPic/Rectangle 8.png')"
            alt="年会现场使用嗨喵大屏互动"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/partyPic/Rectangle 17.png')"
            alt="企业年会使用酒店大屏玩互动游戏"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/partyPic/Rectangle 18.png')"
            alt="企业员工扫码签到祝福年会圆满成功"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/partyPic/Rectangle 19.png')"
            alt="嗨喵大屏互动让企业年会更精彩"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/partyPic/Rectangle 20.png')"
            alt="年会现场使用嗨喵互动摇一摇游戏"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/partyPic/Rectangle 21.png')"
            alt="年会使用嗨喵大屏互动抽奖功能游戏"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/partyPic/Rectangle 22.png')"
            alt="数钞票互动游戏让年会现场更有趣"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/partyPic/Rectangle 23.png')"
            alt="年会来宾使用手机玩嗨喵互动游戏"
            srcset=""
          />
        </div>
      </div>
      <!-- 婚庆相亲 -->
      <div class="items" v-if="place2">
        <div class="item">
          <img
            v-lazy="require('../assets/weddingPic/Rectangle 8.png')"
            alt="婚礼现场使用大屏互动红包雨游戏"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/weddingPic/Rectangle 17.png')"
            alt="结婚使用酒店大屏玩互动游戏"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/weddingPic/Rectangle 18.png')"
            alt="现场来宾扫码签到祝福新婚快乐"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/weddingPic/Rectangle 19.png')"
            alt="嗨喵大屏互动让婚礼现场更欢乐"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/weddingPic/Rectangle 20.png')"
            alt="婚礼现场使用嗨喵互动摇一摇游戏"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/weddingPic/Rectangle 21.png')"
            alt="婚礼使用嗨喵大屏互动抽奖游戏"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/weddingPic/Rectangle 22.png')"
            alt="追新娘互动游戏让结婚现场更有趣"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/weddingPic/Rectangle 23.png')"
            alt="婚礼现场宾客使用手机玩嗨喵互动游戏"
            srcset=""
          />
        </div>
      </div>
      <!-- 酒吧户外 -->
      <div class="items" v-if="place3">
        <div class="item">
          <img
            v-lazy="require('../assets/outsidePic/Rectangle 8.png')"
            alt="潮流酒吧使用嗨喵大屏互动"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/outsidePic/Rectangle 17.png')"
            alt="酒吧现场使用大屏玩互动游戏"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/outsidePic/Rectangle 18.png')"
            alt="酒吧顾客扫码签到表达欢乐心情"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/outsidePic/Rectangle 19.png')"
            alt="嗨喵大屏互动让酒吧现场更精彩"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/outsidePic/Rectangle 20.png')"
            alt="酒吧现场使用嗨喵互动摇一摇游戏"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/outsidePic/Rectangle 21.png')"
            alt="酒吧使用嗨喵大屏互动抽奖功能游戏"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/outsidePic/Rectangle 22.png')"
            alt="数钞票互动游戏让酒吧现场更有趣"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/outsidePic/Rectangle 23.png')"
            alt="酒吧顾客使用手机玩嗨喵互动游戏"
            srcset=""
          />
        </div>
      </div>
      <!-- 企业营销 -->
      <div class="items" v-if="place4">
        <div class="item">
          <img
            v-lazy="require('../assets/marketingAct/Rectangle 8.png')"
            alt="商演庆典现场使用嗨喵大屏互动"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/marketingAct/Rectangle 17.png')"
            alt="庆典峰会使用大屏玩互动游戏"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/marketingAct/Rectangle 18.png')"
            alt="庆典来宾扫码签到祝福活动圆满成功"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/marketingAct/Rectangle 19.png')"
            alt="嗨喵大屏互动让企业营销会更精彩"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/marketingAct/Rectangle 20.png')"
            alt="产品推介会现场使用嗨喵互动摇一摇游戏"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/marketingAct/Rectangle 21.png')"
            alt="庆典峰会使用嗨喵大屏互动抽奖功能游戏"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/marketingAct/Rectangle 22.png')"
            alt="数钞票互动游戏让庆典现场更有趣"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/marketingAct/Rectangle 23.png')"
            alt="营销庆典现场来宾使用手机玩嗨喵互动游戏"
            srcset=""
          />
        </div>
      </div>
    </div>
    <div class="fundation">
      <label-202510 :font-size="30" :text-width="140">基础功能</label-202510>
      <div class="fundationItems">
        <div class="fundationItem">
          <div class="subtitle">16类互动玩法，37项核心功能。全面覆盖活动发布、签到、活动、数据</div>
        </div>
      </div>
    </div>

    <div class="fundationItemscontainer">
      <div class="items">
        <div class="itemcontainer">
          <div class="item">
            <img v-lazy="require('../assets/gamePic/scanSign.gif')" alt="微信扫码签到" srcset="" />
          </div>
          <div class="title">
            <span>微信扫码签到</span>
            <span class="experience-btn" @click="handleExperienceClick('微信扫码签到')"
              >立即体验>></span
            >
          </div>
        </div>
        <div class="itemcontainer">
          <div class="item">
            <img
              v-lazy="require('../assets/gamePic/particleLottery.gif')"
              alt="活动名单抽奖"
              srcset=""
            />
          </div>
          <div class="title">
            <span>活动名单抽奖</span>
            <span class="experience-btn" @click="handleExperienceClick('活动名单抽奖')"
              >立即体验>></span
            >
          </div>
        </div>
        <div class="itemcontainer">
          <div class="item">
            <img
              v-lazy="require('../assets/gamePic/shakeRedEnvelopes.gif')"
              alt="手机摇红包雨游戏"
              srcset=""
            />
          </div>
          <div class="title">
            <span>手机摇红包雨游戏</span>
            <span class="experience-btn" @click="handleExperienceClick('手机摇红包雨游戏')"
              >立即体验>></span
            >
          </div>
        </div>
        <div class="itemcontainer">
          <div class="item">
            <img
              v-lazy="require('../assets/gamePic/whoIsBest.gif')"
              alt="手机摇一摇游戏"
              srcset=""
            />
          </div>
          <div class="title">
            <span>手机摇一摇游戏</span>
            <span class="experience-btn" @click="handleExperienceClick('手机摇一摇游戏')"
              >立即体验>></span
            >
          </div>
        </div>
        <div class="itemcontainer">
          <div class="item">
            <img
              v-lazy="require('../assets/gamePic/countMoney.gif')"
              alt="手机数钞票游戏"
              srcset=""
            />
          </div>
          <div class="title">
            <span>手机数钞票游戏</span>
            <span class="experience-btn" @click="handleExperienceClick('手机数钞票游戏')"
              >立即体验>></span
            >
          </div>
        </div>
        <div class="itemcontainer">
          <div class="item">
            <img
              v-lazy="require('../assets/gamePic/dargonFlyInSky.gif')"
              alt="龙年专属飞龙在天游戏"
              srcset=""
            />
          </div>
          <div class="title">
            <span>龙年专属飞龙在天游戏</span>
            <span class="experience-btn" @click="handleExperienceClick('龙年专属飞龙在天游戏')"
              >立即体验>></span
            >
          </div>
        </div>
        <div class="itemcontainer">
          <div class="item">
            <img
              v-lazy="require('../assets/gamePic/dragonPlaybead.gif')"
              alt="龙年专属游龙戏珠游戏"
              srcset=""
            />
          </div>
          <div class="title">
            <span>龙年专属游龙戏珠游戏</span>
            <span class="experience-btn" @click="handleExperienceClick('龙年专属游龙戏珠游戏')"
              >立即体验>></span
            >
          </div>
        </div>
        <div class="itemcontainer">
          <div class="item">
            <img
              v-lazy="require('../assets/gamePic/signLottery.gif')"
              alt="活动微信扫码签到抽奖"
              srcset=""
            />
          </div>
          <div class="title">
            <span>活动微信扫码签到抽奖</span>
            <span class="experience-btn" @click="handleExperienceClick('活动微信扫码签到抽奖')"
              >立即体验>></span
            >
          </div>
        </div>
        <div class="itemcontainer">
          <div class="item">
            <img
              v-lazy="require('../assets/gamePic/guessMovie.gif')"
              alt="趣味猜电影互动游戏"
              srcset=""
            />
          </div>
          <div class="title">
            <span>趣味猜电影互动游戏</span>
            <span class="experience-btn" @click="handleExperienceClick('趣味猜电影互动游戏')"
              >立即体验>></span
            >
          </div>
        </div>
        <div class="itemcontainer">
          <div class="item">
            <img v-lazy="require('../assets/gamePic/vote.gif')" alt="活动节目投票功能" srcset="" />
          </div>
          <div class="title">
            <span>活动节目投票功能</span>
            <span class="experience-btn" @click="handleExperienceClick('活动节目投票功能')"
              >立即体验>></span
            >
          </div>
        </div>
        <div class="itemcontainer">
          <div class="item">
            <img
              v-lazy="require('../assets/gamePic/giantScreenLottery.gif')"
              alt="3D巨幕抽奖游戏"
              srcset=""
            />
          </div>
          <div class="title">
            <span>3D巨幕抽奖游戏</span>
            <span class="experience-btn" @click="handleExperienceClick('3D巨幕抽奖游戏')"
              >立即体验>></span
            >
          </div>
        </div>
        <div class="itemcontainer">
          <div class="item">
            <img
              v-lazy="require('../assets/gamePic/chaseBride.gif')"
              alt="摇一摇追新娘游戏"
              srcset=""
            />
          </div>
          <div class="title">
            <span>摇一摇追新娘游戏</span>
            <span class="experience-btn" @click="handleExperienceClick('摇一摇追新娘游戏')"
              >立即体验>></span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="knowMore">
      <a class="knowMore" href="https://mp.weixin.qq.com/s/OW4MafDjOO8awQRHR0HEQg" target="_blank"
        >了解更多</a
      >
    </div>

    <label-202510 :font-size="30" :text-width="240" class="whyChooseTitle"
      >为什么选择嗨喵?</label-202510
    >
    <div class="optionsIntroduction">
      <div class="feature-column">
        <div class="feature-icon">
          <img src="@/assets/2025home/zywd.png" alt="专业稳定" />
        </div>
        <div class="feature-title">专业稳定</div>
        <div class="feature-description">
          高性能服务器,超稳超安全。专业工程师、客服人员24小时在线,领先对手不止一步。
        </div>
      </div>
      <div class="feature-separator"></div>
      <div class="feature-column">
        <div class="feature-icon">
          <img src="@/assets/2025home/czbj.png" alt="操作便捷" />
        </div>
        <div class="feature-title">操作便捷</div>
        <div class="feature-description">
          操作简单,机制体验,一分钟创建活动。一台联网电脑,一部手机,轻松应对各种场合。
        </div>
      </div>
      <div class="feature-separator"></div>
      <div class="feature-column">
        <div class="feature-icon">
          <img src="@/assets/2025home/qbmf.png" alt="全部免费" />
        </div>
        <div class="feature-title">全部免费</div>
        <div class="feature-description">18款互动玩法不重样,专业功能全部免费!免费!免费!</div>
      </div>
    </div>
    <label-202510 :font-size="30" :text-width="140" class="classicalCases">经典案例</label-202510>
    <div class="classicalContainer">
      <div class="classicalItem">
        <div class="bg">
          <img
            v-lazy="require('../assets/newhome/Rectangle 31.png')"
            alt="2020年第二届安徽主持人交流峰会使用嗨喵大屏互动"
            srcset=""
          />
        </div>
        <div class="title" style="margin-left: -20px">2020年第二届安徽主持人交流峰会</div>
      </div>
      <div class="classicalItem">
        <div class="bg">
          <img
            v-lazy="require('../assets/newhome/Rectangle 33.png')"
            alt="2021嗨喵与宁波主持团队战略签约仪式"
            srcset=""
          />
        </div>
        <div class="title">2021嗨喵宁波战略签约仪式</div>
      </div>
      <div class="classicalItem">
        <div class="bg">
          <img
            v-lazy="require('../assets/newhome/Rectangle 35.png')"
            alt="嗨喵互动参加世界华人结婚产业颁奖盛典"
            srcset=""
          />
        </div>
        <div class="title">世界华人结婚产业颁奖盛典</div>
      </div>
    </div>
    <label-202510 :font-size="30" :text-width="170" class="partnership">嗨喵合伙人</label-202510>
    <div class="partnershipComment">
      <span class="main">携手、聚势、合作、共赢，嗨喵悦动感谢每一位合伙人老师的付出。</span>
      <a class="clickKnow" target="_blank" href="https://mp.weixin.qq.com/s/jDPuF_BMUU7ykQTw1X-94Q"
        >了解嗨喵合伙人>></a
      >
    </div>
    <div class="partnershipitems">
      <div class="box">
        <div class="item">
          <div class="name">小坤哥</div>
          <div class="name1"></div>
          <div class="title">高级合伙人</div>
        </div>
        <div class="item">
          <div class="name">刘奎</div>
          <div class="name2"></div>
          <div class="title">高级合伙人</div>
        </div>
        <div class="item">
          <div class="name">杨乐</div>
          <div class="name3"></div>
          <div class="title">高级合伙人</div>
        </div>
        <div class="item">
          <div class="name">吴刚</div>
          <div class="name4"></div>
          <div class="title">高级合伙人</div>
        </div>
        <div class="item">
          <div class="name">上小官</div>
          <div class="name5"></div>
          <div class="title">高级合伙人</div>
        </div>
        <div class="item">
          <div class="name">上官</div>
          <div class="name6"></div>
          <div class="title">高级合伙人</div>
        </div>
        <div class="item">
          <div class="name">阿四</div>
          <div class="name7"></div>
          <div class="title">合伙人</div>
        </div>
        <div class="item">
          <div class="name">李照</div>
          <div class="name8"></div>
          <div class="title">合伙人</div>
        </div>
        <div class="item">
          <div class="name">陈宇</div>
          <div class="name9"></div>
          <div class="title">合伙人</div>
        </div>
        <div class="item">
          <div class="name">天宇</div>
          <div class="name10"></div>
          <div class="title">合伙人</div>
        </div>
        <div class="item">
          <div class="name">陈建桥</div>
          <div class="name11"></div>
          <div class="title">合伙人</div>
        </div>
        <div class="item">
          <div class="name">申喆</div>
          <div class="name12"></div>
          <div class="title">合伙人</div>
        </div>
        <div class="item">
          <div class="name">小凡</div>
          <div class="name13"></div>
          <div class="title">合伙人</div>
        </div>
        <div class="item">
          <div class="name">周锋</div>
          <div class="name14"></div>
          <div class="title">合伙人</div>
        </div>
        <div class="item">
          <div class="name">东明</div>
          <div class="name15"></div>
          <div class="title">合伙人</div>
        </div>
        <div class="item">
          <div class="name">刘贝</div>
          <div class="name16"></div>
          <div class="title">合伙人</div>
        </div>
        <div class="item">
          <div class="name">海琳</div>
          <div class="name17"></div>
          <div class="title">合伙人</div>
        </div>
        <div class="item">
          <div class="name">一欣</div>
          <div class="name18"></div>
          <div class="title">合伙人</div>
        </div>
        <div class="item">
          <div class="name">萝卜哥</div>
          <div class="name19"></div>
          <div class="title">合伙人</div>
        </div>
        <div class="item">
          <div class="name">凯钰</div>
          <div class="name20"></div>
          <div class="title">合伙人</div>
        </div>
        <div class="item">
          <div class="name">宣岩</div>
          <div class="name21"></div>
          <div class="title">合伙人</div>
        </div>
        <div class="item">
          <div class="name">天悦</div>
          <div class="name22"></div>
          <div class="title">合伙人</div>
        </div>
        <div class="item">
          <div class="name">马蕊</div>
          <div class="name23"></div>
          <div class="title">合伙人</div>
        </div>
        <div class="item">
          <div class="name">孟良</div>
          <div class="name24"></div>
          <div class="title">合伙人</div>
        </div>
        <div class="item">
          <div class="name">秋傲</div>
          <div class="name25"></div>
          <div class="title">合伙人</div>
        </div>
        <div class="item">
          <div class="name">张鑫瑞</div>
          <div class="name26"></div>
          <div class="title">合伙人</div>
        </div>
        <div class="item">
          <div class="name">黄恒</div>
          <div class="name27"></div>
          <div class="title">合伙人</div>
        </div>
        <div class="item">
          <div class="name">振国</div>
          <div class="name28"></div>
          <div class="title">合伙人</div>
        </div>
        <div class="item">
          <div class="name">小坤哥</div>
          <div class="name1"></div>
          <div class="title">高级合伙人</div>
        </div>
        <div class="item">
          <div class="name">刘奎</div>
          <div class="name2"></div>
          <div class="title">高级合伙人</div>
        </div>
        <div class="item">
          <div class="name">杨乐</div>
          <div class="name3"></div>
          <div class="title">高级合伙人</div>
        </div>
        <div class="item">
          <div class="name">吴刚</div>
          <div class="name4"></div>
          <div class="title">高级合伙人</div>
        </div>
        <div class="item">
          <div class="name">上小官</div>
          <div class="name5"></div>
          <div class="title">高级合伙人</div>
        </div>
      </div>
    </div>
    <div class="customercorpContainer">
      <label-202510 :font-size="30" :text-width="140" class="partnership">合作客户</label-202510>
      <div class="customercorp">
        <div class="item">
          <img
            src="../assets/corPic/WeChatImage_20210612154320.jpg"
            alt="百年老字号同庆楼与嗨喵达成战略合作"
            class="customercorp-n"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/corPic/b98abc1e5e2b67b0b0484a93cdcdffa8.jpg')"
            alt="Host主持团队使用嗨喵大屏互动"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/corPic/c41f6748cedc533b50e9361f124c3e17.jpg')"
            alt="建桥主持团队使用嗨喵主持婚礼活动"
            srcset=""
            class="customercorp-n"
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/corPic/d94a88b74ee8ba241e8ac9c250f8e2cd.jpg')"
            alt="浙江珍爱主持团队与嗨喵互动达成合作"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/corPic/dab6a21bf4a7056412c2eaf1186b029e.jpg')"
            alt="婚尚荟婚庆公司与嗨喵达成合作"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/corPic/e34c509c8f7bdda24ee25a5b59d89a16.jpg')"
            alt="领秀品牌与嗨喵达成合作"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/corPic/efa95de713f8fa8108bb534c0114a6fd.jpg')"
            alt="游羊婚嫁与嗨喵达成合作"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/corPic/WechatIMG76.jpg')"
            alt="南京瑞庭婚礼宴会中心与嗨喵达成合作"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/corPic/WechatIMG77.jpg')"
            alt="艾薇拉婚礼会馆与嗨喵达成合作"
            srcset=""
          />
        </div>
        <div class="item">
          <img
            v-lazy="require('../assets/corPic/WechatIMG78.jpeg')"
            alt="晨丰主持人工作室与嗨喵达成合作"
            srcset=""
          />
        </div>
      </div>
    </div>
    <div class="contact-container">
      <label-202510 :font-size="30" :text-width="140" class="contact-title">联系我们</label-202510>
      <div class="contact-content">
        <div class="contact-top">
          <div class="headline">嗨喵悦动——让互动更精彩</div>
          <button class="contact-btn" @click="handleExperienceClick('联系我们-立即体验')">
            立即体验
          </button>
        </div>
        <div class="contact-body">
          <div class="contact-left">
            <div class="row">
              <img class="icon" src="@/assets/2025home/address-icon.png" alt="地址" />
              <span class="text">地址：上海市普陀区中江路118号</span>
            </div>
            <div class="row">
              <img class="icon" src="@/assets/2025home/phone-icon.png" alt="电话" />
              <span class="text">电话：400-082-2298</span>
            </div>
            <div class="row">
              <img class="icon" src="@/assets/2025home/mail-icon.png" alt="邮箱" />
              <span class="text">邮箱：bd@hudongmiao.com</span>
            </div>
          </div>
          <div class="contact-right">
            <div class="qr">
              <img v-lazy="require('@/assets/image/Code2.jpg')" alt="嗨喵悦动 公众号" />
              <div class="qr-tip">关注我们</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <myFooter />
    <qrcodeBox @closeQrcodeBox="closeQrcodeBox" v-if="qrcodeBoxVisible" />
  </div>
</template>

<script>
import banner from '@/components/layout/banner.vue';
import joymewHeader from '@/components/layout/joymewHeader.vue';
import myFooter from '@/components/myFooter.vue';
import Label202510 from '@/components/custom/label-202510.vue';
import lrBox from '@/components/lrBox.vue';

// import toolBox from '@/components/toolBox.vue';
import qrcodeBox from '@/components/qrcodeBox.vue';
import { CountUp } from 'countup.js';

export default {
  components: {
    banner,
    joymewHeader,
    myFooter,
    Label202510,
    // toolBox,
    qrcodeBox,
    lrBox,
  },
  methods: {
    to(url) {
      window.open(url, '_blank');
    },
    navTo() {},

    handleMessage(e) {
      // console.log(e);
      if (e.data === 'needLogin') {
        this.openLrBox(0);
      }
    },
    handleOpenLogin() {
      this.lrBoxVisible = true;
      this.$nextTick(() => {
        this.$refs.lrBoxDom.openBoxByType(0);
      });
    },
    handleOpenRegister() {
      this.lrBoxVisible = true;
      this.$nextTick(() => {
        this.$refs.lrBoxDom.openBoxByType(2);
      });
    },
    openLrBox(type) {
      this.lrBoxVisible = true;
      this.$nextTick(() => {
        this.$refs.lrBoxDom.openBoxByType(type);
      });
    },
    handleCloseLrBox() {
      this.lrBoxVisible = false;
    },
    handleExperienceClick(text) {
      console.log(text);
      window.open(
        'https://screen.hudongmiao.com/#/?liveId=7b249edb6f5b420c82b31f485080b1a7&screenType=wedding',
        '_blank',
      );
    },
    closeQrcodeBox() {
      this.qrcodeBoxVisible = false;
    },
    openQrcodeBox() {
      this.qrcodeBoxVisible = true;
    },
    show1() {
      this.place1 = false;
      this.place2 = true;
      this.place3 = false;
      this.place4 = false;
    },
    show2() {
      this.place1 = true;
      this.place2 = false;
      this.place3 = false;
      this.place4 = false;
    },
    show3() {
      this.place1 = false;
      this.place2 = false;
      this.place3 = true;
      this.place4 = false;
    },
    show4() {
      this.place1 = false;
      this.place2 = false;
      this.place3 = false;
      this.place4 = true;
    },
    showevent(i) {
      if (i === 0) {
        this.show1();
      } else if (i === 1) {
        this.show2();
      } else if (i === 2) {
        this.show3();
      } else if (i === 3) {
        this.show4();
      }
    },
  },
  created() {
    // pcIndex = 0;
    // loopLock = false;
    // pcLen = this.praiseContentList.length;
  },
  mounted() {
    new CountUp('hdzbf', 15468, {
      duration: 5,
    }).start();
    new CountUp('zcls', 52896, {
      duration: 6,
    }).start();
    new CountUp('hdcc', 865679, {
      duration: 7,
    }).start();
    new CountUp('xccyrc', 103675984, {
      duration: 8,
    }).start();
    const video2 = document.getElementsByTagName('video');

    for (let i = 0; i < video2.length; i += 1) {
      video2[i].controls = false;
    }
    const adaptiveTitle = document.getElementsByClassName('adativeItem');
    for (let i = 0; i < adaptiveTitle.length; i += 1) {
      console.log(i);
      adaptiveTitle[i].addEventListener('mouseover', () => {
        this.showevent(i);
      });
    }
  },
  data() {
    return {
      place2: true,
      place1: false,
      place3: false,
      place4: false,

      qrcodeBoxVisible: false,
      lrBoxVisible: false,
    };
  },
};
</script>

<style lang="less" scoped>
.newhome-go-list {
  margin: 0 auto;
  margin-top: 32px;
  width: 1150px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  .ngl-top {
    width: 100%;
    position: relative;
    z-index: 9;
    display: flex;
    justify-content: space-between;
    img {
      width: 264px;
      aspect-ratio: 1056 / 520;
      transition: all 0.2s;
      &:hover {
        cursor: pointer;
        transform: scale(1.05);
      }
      &:active {
        transform: scale(0.95);
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }

  .ngl-bottom {
    display: flex;
    width: 100%;
    margin-top: 22px;
    justify-content: space-between;
    background: #fff;
    .ngl-bottom-item {
      display: flex;
      width: 264px;
      align-items: center;
      .ngl-bottom-img {
        width: 48px;
        height: 48px;
      }
      .ngl-bottom-info {
        display: flex;
        flex-direction: column;
        margin-left: 13px;
        .count-num {
          font-size: 30px;
          font-weight: bold;
        }
        .label {
          font-size: 18.67px;
        }
      }
    }
  }
}
.contact-container {
  padding: 24px 0 48px;
  .contact-title {
    margin-top: 90px;
    margin-bottom: 30px;
  }
  .contact-content {
    padding: 48px var(--newhome-padding);
    background: #f7a121;
    display: flex;
    flex-direction: column;
    color: #ffffff;
    margin-top: 12px;
    justify-content: flex-start;
    align-items: center;
  }
  .contact-top {
    width: 60%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 0;
    padding-bottom: 48px;
    border-bottom: 1px dashed rgba(255, 255, 255, 0.6);
    margin-bottom: 30px;
  }
  .contact-body {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 60%;
  }
  .contact-left {
    display: flex;
    flex-direction: column;
    gap: 20px;
    flex: 1;
    .row {
      display: flex;
      align-items: center;
      font-size: 18px;
      .icon {
        width: 24px;
        height: 24px;
        margin-right: 10px;
        object-fit: contain;
      }
    }
  }
  .contact-right {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-left: 40px;
    width: 180px;
    .qr {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 120px;
        height: 120px;
        object-fit: contain;
        background: #ffffff;
        padding: 6px;
        border-radius: 4px;
      }
      .qr-tip {
        margin-top: 8px;
        color: #ffffff;
        font-size: 20px;
      }
    }
  }
  .headline {
    font-size: 28px;
    font-weight: bold;
  }
  .contact-btn {
    background: #ffffff;
    color: #f7a121;
    border: none;
    padding: 6px 48px;
    border-radius: 28px;
    font-size: 20px;
    cursor: pointer;
  }
}
video {
  border-radius: 10px;
  width: 100%;
  height: 100%;
  transition: all 0.2s linear;
}
video:hover {
  // height: 500px;
  transform: scale(1.2);
}
.wrapper {
  // height: 879px;
  .carouselImg {
    height: 100%;
    background-size: cover;
    background-position: 50% 50%;
    background-repeat: no-repeat;
  }
}

.adaptivePlace {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 90px;
  .title {
    color: rgba(51, 51, 51, 1);
    font-size: 36px;
    margin-bottom: 13px;
    font-weight: bold;
  }
  .adativeItems {
    width: 1150px;
    margin: 0 auto;
    margin-top: 40px;
    gap: 20px;
    display: flex;
    justify-content: center;
    height: 50px;
    .adativeItem {
      display: flex;
      align-items: center;
      width: 275px;
      cursor: pointer;

      .item-icon {
        width: 24px;
        height: 24px;
        flex-shrink: 0;
      }
      img {
        width: 24px;
        height: 24px;
      }
      .subtitle {
        color: #f7a121;
        background-color: #ffffff;
        border: 2px solid #f7a121;
        text-align: center;
        width: 100%;
        height: 100%;
        font-size: 20px;
        border-radius: 8px;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
      }
      .subtitle1 {
        color: #ffffff;
        background-color: #f7a121;
        border: 2px solid #f7a121;
        text-align: center;
        width: 100%;
        height: 100%;
        font-size: 20px;
        border-radius: 8px;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
      }
      .subtitle:hover {
        background-color: #f7a121;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }
}
.adativeItemscontainer {
  width: 1150px;
  margin: 0 auto;
  margin-top: 29px;
  .items {
    width: 100%;
    flex-wrap: wrap;
    display: flex;
    justify-content: space-between;
    margin-top: 29px;
    .item {
      flex-basis: 275px;
      aspect-ratio: 16 / 9;
      background: rgba(196, 196, 196, 1);
      margin-bottom: 17px;
      border-radius: 8px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}
.fundationItemscontainer {
  width: 1150px;
  margin: 0 auto;
  margin-top: 27px;
  .items {
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .itemcontainer {
      width: 264px;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 40px;
      border-radius: 8px;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
      overflow: hidden;
      background: #ffffff;
      .item {
        width: 100%;
        aspect-ratio: 16 / 9;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .title {
        width: 100%;
        color: #5a5a5a;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 13px 14px;
        .experience-btn {
          color: #f7a121;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
  }
}
.fundation {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 90px;
  .fundationItems {
    width: 950px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    border-bottom: 3px dashed #f7a121;
    padding-bottom: 20px;
    .fundationItem {
      display: flex;
      align-items: center;
      width: 100%;
      img {
        width: 48px;
        height: 48px;
      }
      .subtitle {
        margin-top: 20px;
        color: #5a5a5a;
        text-align: center;
        width: 100%;
        font-size: 20px;
      }
    }
  }
}
.knowMore {
  width: 301px;
  height: 54px;
  background: #f7a121;
  border-radius: 8px;
  line-height: 54px;
  text-align: center;
  margin: 0 auto;
  margin-top: 40px;
  color: rgba(255, 255, 255, 1);
  font-size: 24px;
}
.whyChooseTitle {
  margin-top: 90px;
}
.optionsIntroduction {
  height: 303px;
  background: url("~@/assets/2025home/whychoosehaimiaobg.png") no-repeat center;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 38px;
  padding-top: 40px;

  .feature-column {
    width: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    .feature-icon {
      margin-bottom: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 75px;
      height: 75px;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .feature-title {
      color: rgba(255, 255, 255, 1);
      font-size: 26px;
      font-weight: bold;
      margin-bottom: 15px;
    }

    .feature-description {
      color: rgba(255, 255, 255, 1);
      width: 248px;
      font-size: 16px;
      font-weight: 400;
      line-height: 1.4;
      text-align: center;
    }
  }

  .feature-separator {
    width: 1px;
    height: 200px;
    background-color: rgba(255, 255, 255, 0.3);
  }
}
.classicalCases {
  margin-top: 90px;
  margin-bottom: 40px;
}
.classicalContainer {
  width: 1150px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  .classicalItem {
    width: 463px;
    aspect-ratio: 768 / 568;
    background: url("~@/assets/2025home/classicalitembg.png") no-repeat center;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .bg {
      width: 334px;
      aspect-ratio: 16 / 9;
      margin-top: 36px;
      margin-left: 2px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .title {
      color: #f7a121;
      font-size: 16px;
      margin-top: 10px;
      text-align: center;
      white-space: nowrap;
    }
  }
}
.partnership {
  margin-top: 90px;
  margin-bottom: 26px;
}
.partnershipComment {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 813px;
  border-bottom: 3px dashed #f7a121;
  padding-bottom: 20px;
  margin: 0 auto;
  .main {
    color: #5a5a5a;
    font-size: 20px;
    text-align: left;
  }
  .clickKnow {
    color: #f7a121;
    font-size: 20px;
    border-bottom: none;
    white-space: nowrap;
  }
}
.partnershipitems {
  display: flex;
  width: 1149px;
  margin: 0 auto;
  margin-top: 43px;
  overflow: hidden;
  .box:hover {
    animation-play-state: paused;
    -webkit-animation-play-state: paused;
  }
  .box {
    animation: rolling 60s linear infinite;
    display: flex;
    .item:nth-child(2n) .name {
      background: #f7a121;
      color: rgba(255, 255, 255, 1);
    }
    .item {
      width: 175px;
      margin-right: 20px;
      display: flex;
      text-align: center;
      flex-direction: column;
      align-items: center;
      .name {
        height: 30px;
        line-height: 30px;
        color: #ffffff;
        background-color: #f7a121;
        font-weight: bold;
        font-size: 20px;
        width: 80%;
        border-radius: 16px 0 16px 0; // 特殊圆角：左上、右下
        order: 2;
        margin-top: 12px;
      }
      // 头像容器（除去 .name 与 .title 的 div）
      > div:not(.name):not(.title) {
        order: 1;
        width: 175px;
        height: 175px;
        border-radius: 50%;
        border: 4px solid #f7a121;
        background-size: cover !important;
        background-position: center !important;
        background-repeat: no-repeat !important;
      }
      .name1 {
        width: 100%;
        height: 100%;
        background: url(../assets/hostPIc/25071622011987_.pic.png) no-repeat;
        background-size: 100%;
      }
      .name2 {
        width: 100%;
        height: 100%;
        background: url(../assets/hostPIc/WechatIMG1779.png) no-repeat;
        background-size: 100%;
      }
      .name3 {
        width: 100%;
        height: 100%;
        background: url(../assets/hostPIc/yl.jpg) no-repeat;
        background-size: 100%;
      }
      .name4 {
        width: 100%;
        height: 100%;
        background: url(../assets/hostPIc/24991622011944_.pic_hd.png) no-repeat;
        background-size: 100%;
      }
      .name5 {
        width: 100%;
        height: 100%;
        background: url(../assets/hostPIc/shangxiaoguan.png) no-repeat;
        background-size: 100%;
      }
      .name6 {
        width: 100%;
        height: 100%;
        background: url(../assets/hostPIc/shangguan.png) no-repeat;
        background-size: 100%;
      }
      .name7 {
        width: 100%;
        height: 100%;
        background: url(../assets/hostPIc/asi.png) no-repeat;
        background-size: 100%;
      }
      .name8 {
        width: 100%;
        height: 100%;
        background: url(../assets/hostPIc/24901622011938_.pic_hd.png) no-repeat;
        background-size: 100%;
      }
      .name9 {
        width: 100%;
        height: 100%;
        background: url(../assets/hostPIc/24921622011940_.pic_hd.png) no-repeat;
        background-size: 100%;
      }
      .name10 {
        width: 100%;
        height: 100%;
        background: url(../assets/hostPIc/24911622011939_.pic_hd.png) no-repeat;
        background-size: 100%;
      }
      .name11 {
        width: 100%;
        height: 100%;
        background: url(../assets/hostPIc/WechatIMG2500.png) no-repeat;
        background-size: 100%;
      }
      .name12 {
        width: 100%;
        height: 100%;
        background: url(../assets/hostPIc/24971622011943_.pic_hd.png) no-repeat;
        background-size: 100%;
      }
      .name13 {
        width: 100%;
        height: 100%;
        background: url(../assets/hostPIc/24931622011941_.pic.png) no-repeat;
        background-size: 100%;
      }
      .name14 {
        width: 100%;
        height: 100%;
        background: url(../assets/hostPIc/WechatIMG2529.png) no-repeat;
        background-size: 100%;
      }
      .name15 {
        width: 100%;
        height: 100%;
        background: url(../assets/hostPIc/dongming.png) no-repeat;
        background-size: 100%;
      }
      .name16 {
        width: 100%;
        height: 100%;
        background: url(../assets/hostPIc/24961622011942_.pic_hd.png) no-repeat;
        background-size: 100%;
      }
      .name17 {
        width: 100%;
        height: 100%;
        background: url(../assets/hostPIc/WechatIMG2510.png) no-repeat;
        background-size: 100%;
      }
      .name18 {
        width: 100%;
        height: 100%;
        background: url(../assets/hostPIc/yixinNew.jpg) no-repeat;
        background-size: 100%;
      }
      .name19 {
        width: 100%;
        height: 100%;
        background: url(../assets/hostPIc/24981622011943_.pic_hd.png) no-repeat;
        background-size: 100%;
      }
      .name20 {
        width: 100%;
        height: 100%;
        background: url(../assets/hostPIc/kaiyu.png) no-repeat;
        background-size: 100%;
      }
      .name21 {
        width: 100%;
        height: 100%;
        background: url(../assets/hostPIc/25031622011945_.pic_hd.png) no-repeat;
        background-size: 100%;
      }
      .name22 {
        width: 100%;
        height: 100%;
        background: url(../assets/hostPIc/25051622011946_.pic_hd.png) no-repeat;
        background-size: 100%;
      }
      .name23 {
        width: 100%;
        height: 100%;
        background: url(../assets/hostPIc/WechatIMG1787.png) no-repeat;
        background-size: 100%;
      }
      .name24 {
        width: 100%;
        height: 100%;
        background: url(../assets/hostPIc/25041622011946_.pic.png) no-repeat;
        background-size: 100%;
      }
      .name25 {
        width: 100%;
        height: 100%;
        background: url(../assets/hostPIc/qiuao.png) no-repeat;
        background-size: 100%;
      }
      .name26 {
        width: 100%;
        height: 100%;
        background: url(../assets/hostPIc/WechatIMG2920.png) no-repeat;
        background-size: 100%;
      }
      .name27 {
        width: 100%;
        height: 100%;
        background: url(../assets/hostPIc/25011622011945_.pic_hd.png) no-repeat;
        background-size: 100%;
      }
      .name28 {
        width: 100%;
        height: 100%;
        background: url(../assets/hostPIc/zhenguo.png) no-repeat;
        background-size: 100%;
      }
      img {
        display: block;
        // flex: 1;
        // width: 100%;
        height: 370px;
        // height: 100%;
      }
      .title {
        height: 40px;
        line-height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #f7a121;
        background-color: #ffffff;
        font-size: 20px;
        border: 2px solid #f7a121;
        width: 80%;
        order: 3;
        margin-top: 12px;
        align-text: center;
        border-radius: 999px; // 左右半圆
      }
    }
  }
  @keyframes rolling {
    0% {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
    100% {
      -webkit-transform: translate3d(-5280px, 0, 0);
      transform: translate3d(-5280px, 0, 0);
    }
  }
}
.customercorpContainer {
  .customercorp {
    width: 1150px;
    margin: 0 auto;
    margin-top: 35px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .item {
      margin-bottom: 20px;
      width: 212px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 212px;
      background-color: #ffffff;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
      img {
        height: 100%;
        object-fit: contain;
      }
    }
  }
}
.moreDetail {
  padding: 32px 200px;
  height: 300px;
  display: flex;
  justify-content: space-between;
  .item {
    .title {
      color: rgba(51, 51, 51, 1);
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 4px;
    }
    .detail {
      color: rgba(51, 51, 51, 1);
      font-size: 20px;
      div {
        margin: 8px 0;
      }
    }
  }
}
.bottomLogo {
  width: 459px;
  height: 226px;
  margin: 25px auto;
}
.bottom {
  height: 172px;
  background: rgba(250, 249, 248, 1);
  text-align: center;
  .visionRight {
    color: rgba(255, 204, 79, 1);
    font-size: 20px;
    font-weight: bold;
    padding: 24px 0;
  }
  .huICP {
    display: flex;
    justify-content: center;
    .left {
      margin-right: 48px;
    }
  }
}
.tips {
  width: 100px;
  height: 300px;
  // background: #333;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.2);
  // border: 1px solid #000;
  background: #fff;
  position: fixed;
  top: 742px;
  right: 56px;
  z-index: 99999;
  div {
    width: 100px;
    height: 100px;
  }
  div {
    img {
      width: 30px;
      height: 30px;
    }
    .detail {
      // display: inline-block;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.6);
    }
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
</style>
<style lang="less">
.el-menu--popup {
  // width: 150px;
  min-width: unset;
  border-radius: 8px;
  background-color: #ffffff;
  justify-content: flex-start;
  .sItem {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    &:hover {
      color: #fc9632;
    }
    .versionIcon {
      margin-right: 4px;
      margin-top: -2px;
    }
  }
}
</style>
